// removed by extract-text-webpack-plugin
module.exports = {"Listing":"Listing___2WFgt","containerStandAlone":"containerStandAlone___19jcF","label":"label___2_R94","list":"list___3KA5K","h3":"h3___3zXu7","li":"li___1KXCT","schemas":"schemas___2YO05","delBtn":"delBtn___2RiKH","add":"add___6woYL","handle":"handle___2uwW7","bars":"bars___2VLAg"};


//////////////////
// WEBPACK FOOTER
// /app/js/components/EditorGUI/Listing/styles.scss
// module id = 455
// module chunks = 0